<ng-container *ngIf="currentUserWrapper$ | async as currentUserWrapper; else loadingTemplate">
  <a
    *ngIf="user && link"
    [href]="
      userService.getGalleryUrl(
        user.username,
        !currentUserWrapper.userProfile || currentUserWrapper.userProfile.enableNewGalleryExperience
      )
    "
    [target]="linkTarget"
    (click)="
      userService.openGallery(
        user.username,
        !currentUserWrapper.userProfile || currentUserWrapper.userProfile.enableNewGalleryExperience
      )
    "
    astrobinEventPreventDefault
    astrobinEventStopPropagation
  >
    <ng-container [ngTemplateOutlet]="usernameTemplate"></ng-container>
  </a>
</ng-container>

<ng-container *ngIf="!link" [ngTemplateOutlet]="usernameTemplate"></ng-container>

<ng-template #usernameTemplate>
  <span *ngIf="!!username; else loadingTemplate" class="username d-inline-block">{{ username }}</span>
</ng-template>

<ng-template #loadingTemplate>
  <astrobin-text-loading-indicator></astrobin-text-loading-indicator>
</ng-template>
